var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.type == 1 ? "加价寄件人付费返佣" : "不加价寄件人付运费",
        visible: _vm.dialogVisible,
        "before-close": _vm.closeDialog,
        "append-to-body": "",
        width: "600px",
        "close-on-click-modal": false,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c("div", { staticClass: "content" }, [
        _c("div", { staticClass: "big-img" }, [
          _vm.type == 1
            ? _c("img", {
                staticClass: "img",
                attrs: {
                  src: require("@/assets/images/returnPickupPrint/pic_TipsFY.png"),
                  alt: "",
                },
              })
            : _vm._e(),
          _vm.type == 2
            ? _c("img", {
                staticClass: "img",
                attrs: {
                  src: require("@/assets/images/returnPickupPrint/pic_TipsBJJ.png"),
                  alt: "",
                },
              })
            : _vm._e(),
        ]),
        _vm.type == 1
          ? _c("div", { staticClass: "content-detail" }, [
              _c("div", { staticClass: "big-title y-p-r" }, [
                _c("span", [_vm._v("佣金设置：")]),
              ]),
              _c(
                "div",
                { staticClass: "y-mt-10 padding-left9" },
                [
                  _c("span", { staticClass: "span-text" }, [
                    _vm._v("在现有管家报价的基础上，每单加价"),
                  ]),
                  _c("el-input-number", {
                    staticClass: "y-ml-10",
                    attrs: {
                      precision: 1,
                      step: 0.5,
                      min: 0.5,
                      max: 2.0,
                      size: "small",
                      "step-strictly": true,
                    },
                    model: {
                      value: _vm.brokerage,
                      callback: function ($$v) {
                        _vm.brokerage = $$v
                      },
                      expression: "brokerage",
                    },
                  }),
                  _c("span", { staticClass: "span-text y-ml-10" }, [
                    _vm._v("元佣金设置"),
                  ]),
                ],
                1
              ),
              _c("div", { staticClass: "big-title y-p-r y-mt-10" }, [
                _c("span", [_vm._v("返佣规则：")]),
              ]),
              _c("div", { staticClass: "padding-left9 y-mt-10" }, [
                _c("span", { staticClass: "span-text" }, [
                  _vm._v(
                    "以业务员揽收重量为准，收取寄件人费用；待订单签收后，将加价金额返佣到您的个人支付宝账号。"
                  ),
                ]),
              ]),
              _c(
                "div",
                {
                  staticClass:
                    "padding-left9 y-mt-10 ali-name-box dis-center justify-content-between",
                },
                [
                  _c("div", { staticClass: "dis-center" }, [
                    _c("span", { staticClass: "yuan1" }),
                    _c("span", { staticClass: "span-text y-ml-10" }, [
                      _vm._v("当前已绑定的支付宝收款人 : "),
                    ]),
                    _c("span", { staticClass: "span-text1" }, [
                      _vm._v(
                        _vm._s(_vm.alipayName ? _vm.alipayName : "未绑定")
                      ),
                    ]),
                  ]),
                  _c(
                    "div",
                    { staticClass: "dis-center y-mr-15" },
                    [
                      _vm.isRealNameInfo.cerName
                        ? [
                            _c(
                              "el-popover",
                              {
                                attrs: {
                                  placement: "right",
                                  width: "400",
                                  trigger: "click",
                                },
                              },
                              [
                                _c("div", { staticClass: "real-popover-box" }, [
                                  _c(
                                    "div",
                                    { staticClass: "real-popover-title" },
                                    [_vm._v("查看实名")]
                                  ),
                                  _c("div", { staticClass: "y-pb-15" }, [
                                    _c("div", { staticClass: "tip-txt" }, [
                                      _c("img", {
                                        staticClass: "icon-tip",
                                        attrs: {
                                          src: require("@/assets/images/icon/warning_icon.png"),
                                          alt: "",
                                        },
                                      }),
                                      _vm._v(
                                        "当前实名信息为维护支付宝账号的客户管家账号实名信息"
                                      ),
                                    ]),
                                    _c(
                                      "div",
                                      { staticClass: "real-name-content" },
                                      [
                                        _c("div", [
                                          _c(
                                            "span",
                                            { staticClass: "real-name-label" },
                                            [_vm._v("姓名 :")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            { staticClass: "span-text" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.isRealNameInfo.cerName
                                                )
                                              ),
                                            ]
                                          ),
                                        ]),
                                        _c(
                                          "div",
                                          { staticClass: "margin-top-8" },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass: "real-name-label",
                                              },
                                              [_vm._v("证件类型 :")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              { staticClass: "span-text" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.isRealNameInfo
                                                      .cerTypeName
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "margin-top-8" },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass: "real-name-label",
                                              },
                                              [_vm._v("证件号码 :")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              { staticClass: "span-text" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.isRealNameInfo.cerNo
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]),
                                ]),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "change-account systemColor y-c-p look-content",
                                    attrs: { slot: "reference" },
                                    slot: "reference",
                                  },
                                  [_vm._v("查看实名")]
                                ),
                              ]
                            ),
                          ]
                        : _vm._e(),
                      _vm.isRealNameInfo.cerName
                        ? _c(
                            "span",
                            { staticClass: "y-ml-10 y-mr-10 systemColor" },
                            [_vm._v("|")]
                          )
                        : _vm._e(),
                      _c(
                        "span",
                        {
                          staticClass:
                            "change-account y-ml-10 y-c-p systemColor",
                          attrs: { type: "primary", size: "small" },
                          on: { click: _vm.openSaveAccount },
                        },
                        [_vm._v(_vm._s(_vm.alipayName ? "更换账号" : "去绑定"))]
                      ),
                    ],
                    2
                  ),
                ]
              ),
              _c("div", { staticClass: "padding-left9 y-mt-10 dis-center" }, [
                _c("span", { staticClass: "yuan2" }),
                _vm._v(" "),
                _c("span", { staticClass: "span-text-red y-ml-10" }, [
                  _vm._v(
                    "提示 : 支付宝账号实名信息需与维护支付宝账号的客户管家账号实名信息一致，否则会打款失败。 "
                  ),
                ]),
              ]),
            ])
          : _vm._e(),
        _vm.type == 2
          ? _c("div", { staticClass: "content-detail" }, [
              _c("div", { staticClass: "big-title y-p-r" }, [
                _c("span", [_vm._v("业务规则：")]),
              ]),
              _c("div", { staticClass: "padding-left9 y-mt-10" }, [
                _c("span", { staticClass: "span-text" }, [
                  _vm._v(
                    "以业务员揽收重量为准，按管家的报价和商家设置的付款方式，由寄件人承担运费或寄件人与商家共同承担运费。"
                  ),
                ]),
              ]),
            ])
          : _vm._e(),
      ]),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.closeDialog } },
            [_vm._v("我知道了")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }